<template>
  <div class="employees-panel-wrapper">
    <users-rh-table
      ref="refUsersRhTable"
      :branch="branch"
      :show-options-by-status="showOptionsByStatus"
      :operational-security-crisis="operationalSecurityCrisis"
      :is-read-only="isReadOnly"
      @delete-employee="confirmDelete"
      @save-employee-additional-success="$emit('save-employee-success', $event)"
      @select-employee="openFormEmployee"
    />

    <employee-edit-modal
      :show-modal="showForm"
      :employee-edit="selectedEmployee"
      :branch="branch"
      :affects-users-rh="affectsUsersRh"
      :shelters-by-municipality="sheltersByMunicipality"
      :operational-security-crisis="operationalSecurityCrisis"
      :show-options-by-status="showOptionsByStatus"
      :is-read-only="isReadOnly"
      @save-affectation="handleSaveAffectation"
      @save-employee-success="$emit('save-employee-success', $event)"
      @update:isActive="closeFormEmployee"
    />
  </div>
</template>

<script>
import {ref, watch} from '@vue/composition-api';
import axios from "@/libs/axios";
import {useToast} from "vue-toastification/composition";
import Swal from "sweetalert2";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import EmployeeEditModal from './EmployeeEditModal.vue';
import UsersRhTable from './UsersRhTable.vue';

export default {
  name: "EmployeesTab",
  components: {
    EmployeeEditModal,
    ToastificationContent,
    UsersRhTable,
  },
  props: {
    affectsUsersRh: {
      type: Object,
    },
    branch: {
      type: Object,
      required: true,
    },
    employees: {
      type: Array,
      default: () => [],
    },
    sheltersByMunicipality: {
      type: Object,
    },
    operationalSecurityCrisis: {
      type: Object
    },
    showOptionsByStatus: {
      type: Boolean
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: true
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    refreshVersion: {
      type: Number,
      default: 0
    }
  },
  setup(props, {emit}) {
    const toast = useToast();
    const refUsersRhTable = ref(null);
    const selectedEmployee = ref(null);
    const showForm = ref(false);

    const closeFormEmployee = () => {
      showForm.value = false;
      selectedEmployee.value = null;
    }

    const confirmDelete = (employeeDelete, origin) => {
      if (props.isReadOnly) {
        return;
      }

      Swal.fire({
        title: `¿Eliminar al empleado ${employeeDelete.soeid} del formulario de crisis?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const params = {
            id_unit: props.branch.id_unit,
            id_user_rh: employeeDelete.id_user_rh
          }

          axios
            .delete(`/v1/operational-security-crisis/${props.operationalSecurityCrisis.id}/users-rh/delete`, {params})
            .then((response) => {
              const {data} = response;

              refresh(origin);

              toast({
                component: ToastificationContent,
                props: {
                  title: data.message,
                  icon: "CheckIcon",
                  variant: "success",
                },
              });
            });
        }
      });
    }

    const openFormEmployee = (employeeEdit) => {
      if (props.isReadOnly) {
        return;
      }

      selectedEmployee.value = employeeEdit;
      showForm.value = true;
    }

    const handleSaveAffectation = (branch, affectsWithLackOfPublicTransportation) => {
      emit('save-affectation', branch, affectsWithLackOfPublicTransportation);
    }

    const refresh = () => {
      if (refUsersRhTable.value) {
        refUsersRhTable.value.refetchData();
      }
    }

    watch(() => props.refreshVersion, () => {
      // Remote unit patches refresh the table only when this tab is visible.
      if (props.isActive) {
        refresh();
      }
    });

    return {
      refUsersRhTable,
      selectedEmployee,
      showForm,

      closeFormEmployee,
      confirmDelete,
      handleSaveAffectation,
      openFormEmployee,
    }
  },
}
</script>

<style lang="scss" scoped>
.employees-panel-wrapper {
  position: relative;
  min-height: 100px;
}
</style>
